import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const NotificationsIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M14.928 6.373A.703.703 0 0 0 14.3 6H8.782L9.396.74a.663.663 0 0 0-.434-.692.72.72 0 0 0-.817.211l-7 8.666a.64.64 0 0 0-.073.702.704.704 0 0 0 .629.372h5.518l-.614 5.26a.663.663 0 0 0 .434.692.725.725 0 0 0 .817-.212l7-8.666a.642.642 0 0 0 .072-.701Z", fill: "currentColor" })));
});
NotificationsIcon.displayName = 'NotificationsIcon';
export default NotificationsIcon;
